'use strict';
import { CookieDisclaimer } from './class-cookie-disclaimer';
// import './dialog-cookie-disclaimer.scss';

document.addEventListener( 'DOMContentLoaded', () => {
	// Loads the featured story rotation
	new CookieDisclaimer();
} );
